import { render, staticRenderFns } from "./TicketTypeEvents.vue?vue&type=template&id=a541cbfc&scoped=true"
import script from "./TicketTypeEvents.vue?vue&type=script&lang=js"
export * from "./TicketTypeEvents.vue?vue&type=script&lang=js"
import style0 from "./TicketTypeEvents.vue?vue&type=style&index=0&id=a541cbfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a541cbfc",
  null
  
)

export default component.exports